import $http from "../axios";

const state = {
  ownerInfo: {},
  companyInfo: {},
  address: {},
  bankInfo: {},
  payments: {},
  biUrl: "",
  preferences: {
    storesOrder: "chronological",
    timezone: -3
  },
  permissions: {},
  role: null,
  operatorInfo: {},
  openMart: null,
  rewardProgram: {}
};

const getters = {
  ownerInfo: state => {
    return state.ownerInfo;
  },

  companyInfo: state => {
    return state.companyInfo;
  },

  address: state => {
    return state.address;
  },

  bankInfo: state => {
    return state.bankInfo;
  },

  payments: state => {
    return state.payments;
  },

  biUrl: state => {
    return state.biUrl;
  },

  preferences: state => {
    return state.preferences;
  },

  permissions: state => {
    return state.permissions;
  },

  role: state => {
    return state.role;
  },

  operatorInfo: state => {
    return state.operatorInfo;
  },

  openMart: state => {
    return state.openMart;
  },

  rewardProgram: state => {
    return state.rewardProgram;
  }
};

const actions = {
  getAccountData({ commit }, email) {
    if (!email) {
      return new Promise((resolve, reject) => {
        $http
          .get("account-data")
          .then(res => {
            if (res.data.result === "ok") {
              commit("SET_ACCOUNT_DATA", res.data.payload);
              commit("SET_PURCHASES", res.data.payload);
            }
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
      });
    }
    return { data: { result: "ok" } };
  },

  getOpenMartIframeAuth({ commit }) {
    commit("SET_OPEN_MART", null);
    return $http.get("open-mart/iframe-auth").then(res => {
      if (res.data.result === "ok") {
        commit("SET_OPEN_MART", res.data.payload);
      }
      return res;
    });
  },

  updatePassword(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-password", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateStoresOrderPreference({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-stores-order-preference", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_STORES_ORDER_PREFERENCE", data.storesOrder);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  updateTimezone({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("update-timezone", data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("UPDATE_TIMEZONE", data.timezone);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  saveDashboardBISettings({ commit }, settings) {
    return new Promise((resolve, reject) => {
      $http
        .post("save-dashboard-bi-settings", { settings })
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_DASHBOARD_BI_SETTINGS", res.data.payload || settings);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  clearAccountData({ commit }) {
    commit("CLEAR_ACCOUNT_DATA");
  }
};

const mutations = {
  SET_ACCOUNT_DATA(state, data) {
    state.ownerInfo = data.ownerInfo;
    state.companyInfo = data.companyInfo;
    state.address = data.address;
    state.bankInfo = data.bankInfo;
    state.payments = data.payments;
    state.biUrl = data.biUrl;
    state.preferences = data.preferences || {};
    if (!state.preferences.dashboardBI) {
      state.preferences.dashboardBI = {};
    }
    state.operatorInfo = data.operatorInfo;
    state.rewardProgram = data.rewardProgram;
  },

  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },

  SET_ROLE(state, role) {
    state.role = role;
  },

  UPDATE_STORES_ORDER_PREFERENCE(state, storesOrder) {
    state.preferences.storesOrder = storesOrder;
  },

  UPDATE_TIMEZONE(state, timezone) {
    state.preferences.timezone = timezone;
  },

  SET_DASHBOARD_BI_SETTINGS(state, settings) {
    if (!state.preferences) {
      state.preferences = {};
    }
    state.preferences.dashboardBI = settings || {};
  },

  SET_OPEN_MART(state, data) {
    state.openMart = data;
  },

  CLEAR_ACCOUNT_DATA(state) {
    state.ownerInfo = {};
    state.companyInfo = {};
    state.address = {};
    state.bankInfo = {};
    state.payments = {};
    state.biUrl = "";
    state.operatorInfo = {};
    state.openMart = null;
    state.rewardProgram = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
